<template>
  <b-modal id="modalDetalheAdicional" :header-text-variant="'text-center'" size="lg"  title="Aquisição de adicionais" cancel-title='Fechar' hide-footer
  @show="resetarDados"
  @hidden="tratarEventoFecharModal"
  :static="true" :lazy="true">
    <template #modal-header="{ close }">
      <h4 class="ml-auto mr-auto">Aquisição de adicionais</h4>
      <button class="botoes btn btn-light" @click="close()">X</button>
    </template>
    <spinnerProcessando cssClass="ml-2" :status="flagsDeControle.carregandoDados.status" :mensagem="flagsDeControle.carregandoDados.mensagem"/>
    <h3>{{obterTituloModal}}</h3>
    <div class="video embed-responsive embed-responsive-16by9 mt-4 m-auto" v-if="produto.url_video">
      <iframe class="embed-responsive-item"
        :src="produto.url_video"
        title="YouTube video player" frameborder="0">
      </iframe>
    </div>
    <div class="mt-5">
      <table class="table table-sm">
      <thead>
        <tr class="bg-light">
          <th scope="col" class="text-center">Seleção</th>
          <th scope="col" class="text-left">Opções</th>
          <th v-if="produto.planos.some(plano => plano.tipo === 2)" scope="col" class="text-left">Validade</th>
          <th scope="col" class="text-right">Valor</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="plano of produto.planos" :key="plano.id" @click="planoSelecionado = plano" style="cursor: pointer;">
          <td class="text-center">
            <input type="radio" name="plano_selecionado" :id="'plano_selecionado_'+plano.id" :disabled="flagsDeControle.carregandoDados.status" v-model="planoSelecionado" :value="plano">
          </td>
          <th scope="row">
            <label :for="'plano_selecionado_'+plano.id" class="mr-3 w-100" v-if="temIlimitado(plano)">
              Pacote ilimitado
            </label>
            <label v-else class="mr-3 w-100">
              Pacote com {{obterQuantidadeItemPlano(plano)}} {{obterNomeItemPlano(plano)}}
            </label>
            <span v-if="plano.sugerido" class="px-2 badge badge-success small">Recomendado</span>
          </th>
          <td v-if="produto.planos.some(plano => plano.tipo === 2)">
            <label v-if="plano.tipo == 2">{{ plano.qtd_dias_validade_credito }} dias</label>
          </td>
          <td class="text-right text-bold">{{formatarValorMonetario(plano.valor)}}</td>
        </tr>
      </tbody>
      </table>
      <div class="d-flex flex-column d-flex align-items-center justify-content-center">
        <div class="mb-3">
          <b-form-checkbox
            id="aceite_termos"
            v-model="formulario.aceite_termos"
            name="aceite_termos"
            :value="true"
            class="px-5"
            :unchecked-value="false"
          >
            <label for="aceite_termos">
              Ao continuar, aceito os <a href="/pdf/Termos_de_Uso_Mirt.pdf"  target="_blank">Termos de Uso</a>
              e <a href="/pdf/Politica_de_Privacidade_Mirt.pdf" target="_blank">Política de Privacidade</a>
            </label>
          </b-form-checkbox>
          <b-form-checkbox
            v-if="duplaChecagem"
            id="confirma_exclusao"
            v-model="confirmou"
            name="confirma_exclusao"
            class="px-5"
            :value="true"
            :unchecked-value="false"
          >
            <label for="confirma_exclusao">
              Existe uma troca de plano no seu carrinho de compras que será excluído para que possa efetuar compra de outros produtos. Deseja continuar?
            </label>
          </b-form-checkbox>
          <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.aceite_termos}}</div>
        </div>
        <div class="w-75" v-if="!duplaChecagem">
          <button class="botoes btn btn-lg btn-block botao" :disabled="flagsDeControle.carregandoDados.status" @click="adicionar()">Adicionar</button>
        </div>
        <div class="w-75" v-else>
          <button class="botoes btn btn-lg btn-block botao" :disabled="!confirmou || !formulario.aceite_termos" @click="adicionar()">Continuar</button>
        </div>
      </div>
      <div v-if="produto.descricao" class="mt-5">
        <hr>
        <h3>Sobre o pacote adicional</h3>
        <p v-html="produto.descricao"></p>
      </div>
    </div>
  </b-modal>
</template>

<script>
import DetalheAdicional from './js/detalhe-adicional'
export default DetalheAdicional
</script>

<style scoped>
.video {
  width: 95%;
  max-height: 350px;
}
</style>
